import {Injectable} from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class CookieService {

    constructor() {
    }

    /**
     * Set cookie
     * @param name
     * @param value
     * @param expDays
     */
    static set(name: string, value: any, expDays: number = 30) {
        const d = new Date();
        d.setTime(d.getTime() + (expDays * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${value.toString()};expires=${d.toUTCString()};path=/`;
    }

    /**
     * Get cookie
     * @param name
     */
    static get(name: string): string | undefined {
        const allCookies = decodeURIComponent(document.cookie);
        return allCookies.split(';')
            .find(c => c.trim().split('=')[0] === name)?.split('=')[1];
    }
}
